<template lang="pug">
  .import.import-excel(
    @click="showList=false"
    :class="{ dragging: dragInProgress }"
  )
    e-form-modal(
      :showSaveButton='false'
      cancelBtnLabel='Вернуться'
    )
      div(slot="header" style="flex-grow:1")
        e-breadcrumbs
        h1.modal__title
          template Импорт данных
      .modal__body
        .import__year(v-if='hasYear' )
          label.label.semibold Укажите год
          select.select(v-model='year' @change='changeYear')
            option(v-for="option in yearsOptions" :value="option") {{option}}
        .body.body-import.display-block(v-if="userCanCreate")
          div(
            @drag.stop.prevent="onDragEnd"
            @dragover.stop.prevent="onDragStart"
            @dragstart.stop.prevent="onDragStart"
            @dragenter.stop.prevent="onDragStart"
            @dragend.stop.prevent="onDragEnd"
            @dragleave.stop.prevent="onDragEnd"
            @drop.stop.prevent="onFileDrop"
          ).upload-files
            .upload-files__wrapper
              .upload-content
                div.icon.upload-files__icon
                div.info.upload-files__info
                  p.blue.upload-file__label Перетащите файлы в эту область
                  p.upload-file__support Поддерживаемые форматы - .xls, .xlsx
                div.file-upload
                  label.file-upload__label.upload-files__label(for="upload") Загрузить
                  input(
                    id="upload"
                    type="file" @change="addFile"
                    v-if="enableFileUpload"
                  ).file-upload__input.visually-hidden

        e-table(
          :items="items"
          :showEditButton="false"
          :showCheckbox="false"
          :scrollUpdateStreamName="scrollUpdateStreamName"
          animationName="new-row"
          actionColumnWidth="270"
        )
          template(slot="file_name" slot-scope="props")
            a(
              @click.stop.prevent="downloadFile(props.row)"
            ) {{props.row.file_name}}
          template(slot="error_count" slot-scope="props")
            template(v-if="props.row.errorFile")
              a(
                @click.stop.prevent="downloadErrorFile(props.row)"
              ).blue {{`${props.row.error_count} `}}
                span.save.blue Скачать
          template(slot="actionButtons" slot-scope="props")
            div.buttons
              div.progress
                div(
                  :style="{width: `${props.row.load_progress || 0}%`}"
                  :class="{'progress__loaded_success': isSuccessfullyLoaded(props), 'progress__loaded_failed': isFailedLoaded(props)}"
                ).progress__loaded
          div(slot="tableLeftFilterPanel").template-list
            button(@click.prevent.stop="showList = !showList").template-list__title.reset-btn.button Скачать шаблон загрузки
            div(:class="showList ? 'opened' : 'closed'").template-list__body
              template(
                v-if="templates && typeof templates === 'object' && Object.keys(templates).length > 0"
              )
                a(
                  v-for="(template, code) in templates"
                  @click="getTemplate(template, code)"
                ).template-list__item {{template.name}}
              a(v-else) Нет доступных для загрузки шаблонов
</template>

<script>
import { ROUTE_NAME_TYPE_MAP } from '@/config/import'
import { importEndpoints } from '@/api/api-endpoints'
import {
  IMPORT_STATUS_CODE_CANCELED,
  IMPORT_STATUS_CODE_PROCESSING,
  IMPORT_STATUS_CODE_QUEUED,
} from '@/app/import/utils/types'
import importMixin from './mixins/import-mixin'
import RouteMixin from '@/mixins/route-mixin'

export default {
  mixins: [importMixin, RouteMixin],
  computed: {
    supportedFormat() {
      return ['xls', 'xlsx']
    },
    yearsOptions() {
      return this.$store.state.years
    },
  },
  methods: {
    isSuccessfullyLoaded(props) {
      return (
        props?.row?.importStatus?.code === IMPORT_STATUS_CODE_QUEUED ||
        props?.row?.importStatus?.code === IMPORT_STATUS_CODE_PROCESSING
      )
    },
    isFailedLoaded(props) {
      return (
        props?.row?.importStatus?.code !== IMPORT_STATUS_CODE_CANCELED &&
        props?.row?.errorFile
      )
    },
    getType(route) {
      let type = null
      let typeCandidate = null
      if (route.query && route.query.fromName) {
        let name = route.query.fromName
        for (let fromName in ROUTE_NAME_TYPE_MAP) {
          if (name === fromName) {
            type = ROUTE_NAME_TYPE_MAP[fromName]
            break
          }
          // Поиск по вхождению менее приоритетный
          if (name.indexOf(fromName) > -1) {
            typeCandidate = ROUTE_NAME_TYPE_MAP[fromName]
          }
        }
      }

      if (type === null) {
        type = typeCandidate
        // fix: https://redmine.etton.ru/issues/13405
        // TODO: fix it
        /* store.commit(
            'mutateError',
            new Error('Невозможно определить тип импорта данных. Вероятно вы перешли по неверной ссылке.')
          ) */
      }
      return type
    },
    getDownloadTemplateEndpoint(code) {
      return importEndpoints.templateDownload(code)
    },
    getTemplateEndpoint(route, type) {
      return importEndpoints.template(type)
    },
    getEndpoint(route, type) {
      const year = this.year
      return importEndpoints.files(route, type, year)
    },
    getDeleteUrl(id, type, item = {}) {
      let importFile = item.file || { import_file_id: null }
      return importEndpoints.fileDataDelete(id, type, {
        query: {
          file_id: item.file_id,
          item_id: item.id,
          import_file_id: importFile.import_file_id,
        },
      })
    },
    getUploadUrl() {
      return importEndpoints.fileUpload()
    },
    getServerQueueEndpoint(id) {
      return importEndpoints.fileToServerQueue(id)
    },
    changeYear() {
      let prevRoute = JSON.parse(this.$route.query.prevRoute)
      prevRoute.query.year = this.year
      prevRoute = JSON.stringify(prevRoute)
      this.replaceRoute({ prevRoute })

      this.reFetchData()
    },
  },
}
</script>

<style scoped>
>>> .content {
  display: flex;
  flex-direction: column;
  padding: 0;
}

>>> .table {
  flex-grow: 1;
}

.template-list {
  margin-top: -10px;
}

.import__year {
  width: 200px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
}
</style>
